const renderTooltipModal = ($) => {
	const body = $("body");
	const tooltipWord = $(".tooltip__word");
	const tooltipModal = $(".tooltip__modal");
	const tooltipDefinition = $(".tooltip__definition");
	const closeIcon = $(".tooltip-mobile-close-icon");
	const screenWidth = $(window).width();

	// Function to handle opening the tooltip modal on touch screens
	function openTooltipModal() {
		let triggerWord = $(this).attr("data-id");
		let targetTooltipModal = $(`.${triggerWord}`);

		// Open the clicked modal
		targetTooltipModal.addClass("js-open-tooltip-modal");
		body.css("overflow", "hidden");
		tooltipDefinition.css("overflow", "scroll"); // Enable scrolling when modal is open
	}

	// Function to handle closing the tooltip modal on touch screens
	function closeTooltipModal() {
		setTimeout(function () {
			// workaround needed for removeClass to work
			$(".tooltip__modal").removeClass("js-open-tooltip-modal");
			body.css("overflow", "unset");
			tooltipDefinition.css("overflow", "unset"); // Enable scrolling when modal is open
		}, 10);
	}

	// function to handle showing the tooltip definition on desktop when using keyboard
	function hoverToolTip() {
		let targetTooltipWord = $(this);
		let targetTooltipModal = targetTooltipWord
			.closest(".tooltip__word")
			.find(".tooltip__definition");

		targetTooltipModal.addClass("js-view-hover");
	}

	// function to handle closing the tooltip definition on desktop
	function closeTooltipHover() {
		$(".tooltip__definition").removeClass("js-view-hover");
	}

	// Function to handle keyboard interactions
	function handleKeyboardEvents(e) {
		if (
			e.key === "Escape" &&
			$(".tooltip__modal.js-open-tooltip-modal").length > 0
		) {
			closeTooltipModal();
		} else if (e.key === "Escape" || e.key === "Tab") {
			closeTooltipHover();
		}
	}

	// Functions to run on touch screens
	if (screenWidth < 1024 && tooltipModal.length > 0) {
		tooltipWord.on("click", openTooltipModal);
		closeIcon.on("click", closeTooltipModal);

		// Open the modal when Tab key is pressed
		tooltipWord.on("keydown", (e) => {
			if (e.key === "Tab" && !e.shiftKey) {
				openTooltipModal.call(this);
			}
		});

		$(document).on("keydown", handleKeyboardEvents);
	}

	// Functions to run on desktop when using keyboard
	if (screenWidth > 1024) {
		tooltipWord.on("keydown", function (e) {
			if (e.key === "Enter") {
				hoverToolTip.call(this);
			}
		});

		$(document).on("keydown", handleKeyboardEvents);
	}
};

export default renderTooltipModal;
